import styled from "styled-components";

export const LightSocketDefaultBox = styled.div<{socketIndex: number; totalSockets: number;}>`
    position: absolute;
    width: 100%;
    height: 100%;

    /** TODO: This rotate is exactly as in light-bulb.box but negative. Extract in a mixin */
    transform: rotate(${props => 15 + (props.socketIndex * 360 / props.totalSockets)}deg);
`;
